var map = {
	"./404.png": 99411,
	"./auth-background.png": 53016,
	"./auth-background2.png": 81656,
	"./clock.png": 45201,
	"./cv-icon.png": 60080,
	"./cv.png": 77324,
	"./ellisse1.svg": 82145,
	"./ellisse2.svg": 77106,
	"./ellisse3.svg": 31395,
	"./footer/app_store.png": 96176,
	"./footer/app_store.svg": 75732,
	"./footer/crunchbase-icon.svg": 12357,
	"./footer/google_cloud.png": 22420,
	"./footer/google_play.png": 18641,
	"./footer/google_play.svg": 95765,
	"./footer/instagram-icon.svg": 79899,
	"./footer/linkedin-icon.svg": 88199,
	"./footer/microsoft_startups.svg": 1756,
	"./footer/ministero.webp": 19420,
	"./footer/puglia_fse.svg": 6360,
	"./footer/regione_puglia.svg": 89623,
	"./footer/unione_europea.svg": 73529,
	"./google_meet_logo.png": 318,
	"./help-background.png": 61061,
	"./lessons/andrea.png": 4388,
	"./lessons/davide.png": 2906,
	"./linkedin.png": 95405,
	"./logo-color.svg": 40828,
	"./logo-white.svg": 27270,
	"./megaphone-icon.png": 61055,
	"./openhr/status/active-reciprocal.png": 23674,
	"./openhr/status/active-to-me.png": 7686,
	"./openhr/status/active-to-others.png": 37581,
	"./openhr/status/revoked-reciprocal.png": 81618,
	"./openhr/status/revoked-to-me.png": 77102,
	"./openhr/status/revoked-to-others.png": 49477,
	"./openhr/status/to-activate-reciprocal.png": 36989,
	"./openhr/status/to-activate-to-me.png": 26631,
	"./openhr/status/to-activate-to-others.png": 32004,
	"./openhr/status/waiting-reciprocal.png": 511,
	"./openhr/status/waiting-to-me.png": 24029,
	"./openhr/status/waiting-to-others.png": 18806,
	"./static-job-image1.png": 92966,
	"./static-job-image2.png": 34205,
	"./teams_logo.png": 37775,
	"./video-cv.png": 33462,
	"./wh-shield.png": 42402,
	"./zoom_logo.png": 89370
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 73811;